var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bathrooms-filter" }, [
    _c("h5", [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "btn-group form-group",
        attrs: { "data-toggle": "buttons" }
      },
      [
        _vm._l(4, function(bathroom) {
          return [
            _c(
              "label",
              {
                key: bathroom,
                staticClass: "btn btn-primary",
                class: _vm.current_value == bathroom ? "active" : ""
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.current_value,
                      expression: "current_value"
                    }
                  ],
                  attrs: { name: "bathrooms", type: "radio" },
                  domProps: {
                    value: bathroom,
                    checked: _vm._q(_vm.current_value, bathroom)
                  },
                  on: {
                    click: function($event) {
                      return _vm.onClick(bathroom)
                    },
                    change: function($event) {
                      _vm.current_value = bathroom
                    }
                  }
                }),
                _vm._v(
                  " " +
                    _vm._s(bathroom == 4 ? bathroom + "+" : bathroom) +
                    "\n            "
                )
              ]
            )
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }